import { jsxs as c, jsx as i } from "react/jsx-runtime";
import { clsx as m } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useRef as x } from "react";
import { Breakpoints as N } from "../../style/base/index.js";
import { useBreakpointMatch as T } from "../../utils/use-breakpoint-match.js";
import { useIsVisibleOnce as C } from "../../utils/use-is-visible.js";
import { VideoJS as M } from "./aws/index.js";
import r from "./roche-video-player.module.scss.js";
import { YouTubeVideoPlayerService as R } from "./youtube/index.js";
const D = ({
  awsServiceBaseUrl: o,
  service: f,
  fullscreen: l,
  videoLoop: e,
  fillParentHeight: h,
  caption: t,
  copyright: n,
  slot: y,
  ...s
}) => {
  const a = x(null), v = C(a), g = T(N.MEDIUM), d = () => l ? e ? !0 : !g : !1, u = () => /* @__PURE__ */ i("div", { ref: a, className: b }), V = (p) => {
    switch (p) {
      case "youtube":
        return /* @__PURE__ */ i(R, { fullscreen: d(), ...s });
      case "aws":
        if (o) {
          const P = `${o}${s.videoId}/hls/main.m3u8`;
          return /* @__PURE__ */ i(
            M,
            {
              awsServiceBaseUrl: o,
              fullscreen: d(),
              videoLoop: e,
              options: {
                fluid: !0,
                preload: e ? "auto" : "none",
                muted: e,
                loop: e,
                autoplay: e,
                controls: !0,
                playsinline: !!e,
                disablePictureInPicture: !0,
                fullscreen: { navigationUI: "hide" },
                controlBar: {
                  fullscreenToggle: !0,
                  pictureInPictureToggle: !1
                },
                sources: [
                  {
                    src: P,
                    type: "application/x-mpegURL"
                  }
                ]
              },
              ...s
            }
          );
        }
        return console.error("Trying to render AWS video service without supplying video service URL"), u();
      default:
        console.info(`Trying to render not-implemented video service: - ${p}`);
        break;
    }
  }, _ = () => (t || n) && /* @__PURE__ */ c("div", { className: r["video-description"], children: [
    t && /* @__PURE__ */ i("figcaption", { className: r["video-description__caption"], children: t }),
    n && /* @__PURE__ */ c("div", { className: r["video-description__copyright"], children: [
      "© ",
      n
    ] })
  ] }), b = m(
    r["video-player__placeholder"],
    l && r["video-player__placeholder--fullscreen"]
  ), I = m(
    r["video-player"],
    h && r["video-player--fill-parent-height"],
    l && !e && r["video-player--fullscreen"]
  );
  return v ? /* @__PURE__ */ c("div", { className: I, slot: y, children: [
    V(f),
    _()
  ] }) : u();
};
export {
  D as RocheUIVideoPlayer
};
